import Cookie from 'js-cookie'
import ajax from 'js/ajax'

function getBasicParams() {
  return {
    f: 'jsonp',
    version: 1,
    toptime: 1458112314,
    bottomtime: 1458112314,
    timeline: 13333645,
    type: 'video',
    page: 1
  }
}

function createError(code, msg, data = {}) {
  let error = new Error(msg)
  error.code = code
  error.data = data
  return error
}

function createFetch(url, data) {
  return new Promise(function (resolve, reject) {
    ajax({
      url: process.env.VUE_APP_BASE_API + url,
      dataType: 'jsonp',
      timeOut: 5000,
      data: data,
      callback: url.replace(/\//g, ''),

      success: function (res) {
        resolve(res)
      },

      error: function (error) {
        reject(error)
      }
    })
  }).then(res => {
    return res
  })
}

function channelFetch(url) {
  return new Promise(function (resolve, reject) {
    ajax({
      url: process.env.VUE_APP_BASE_API + url,
      timeOut: 5000,
      callback: url.replace(/\//g, ''),

      success: function (res) {
        resolve(res)
      },

      error: function (error) {
        reject(error)
      }
    })
  }).then(res => {
    return res
  })
}

export const fetchList = (data) => {
  let obj
  if (!data.key) {
    obj = {
      count: data.count,
      offset: data.offset,
      feedssession: data.feedssession,
      fromId: data.fromId,
      channel: data.channel,
      source: data.source,
      session: data.session ? data.session : '',
      firstRefreshTime:data.firstRefreshTime,
      refreshTimes:data.refreshTimes + '',
      appId:'h5'
    }
  } else {
    obj = {
      count: data.count,
      offset: data.offset,
      feedssession: data.feedssession,
      session: data.session ? data.session : '',
      firstRefreshTime:data.firstRefreshTime,
      refreshTimes:data.refreshTimes + '',
      appId:'h5'
    }
  }
  const params = Object.assign({}, getBasicParams(), obj)
  // if (data.page === 2) {
  //   return Promise.resolve({articles: []})
  // }
  if(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)){
    params.use_webp = '0';
  }else{
    params.use_webp = '1';
  }
  return createFetch('video/getListH5', params)
}

export const getNavList = (data = {}) => {
  return channelFetch('v1/channel/getH5Channels')
}
// http://ivideo.test-browser.wanyol.com/video/videoInfo?source=oppoSelfNews&docid=oppoSelfNews3912&f=json
export const fetchVideoInfo = (data = {}) => {
  const params = Object.assign({}, {
    f: 'jsonp',
    source: data.source,
    docid: data.docid,
    feedssession: Cookie.get('c_session_id'), //用户session信息
    session: Cookie.get('c_session') || '', //用户session信息
    appId:'h5'
  })
  return createFetch('video/videoInfo', params)
}

export const fetchRelateVideoList = (data = {}) => {
  const params = Object.assign({}, data, {
    f: 'jsonp', // 返回格式，json/jsonp
    feedssession: Cookie.get('c_session_id') || '', // 第一次调用时不带，在第一次的返回结果中输出，后续调用需携带，用户session信息
    session: Cookie.get('c_session') || '', // 第一次调用时不带，在第一次的返回结果中输出，后续调用需携带，用户session信息
    mediaNo:data.mediaNo,
    appId:'h5'
  })
  return createFetch('video/recVideo', params )
}

